import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const DIFFICULTY_LABELS = { easy: 'Fácil', medium: 'Média', hard: 'Difícil' };

function DifficultySummary({ difficulty }) {
  if (!difficulty?.target) return null;
  return <p className="text-xs text-muted-foreground">{['easy', 'medium', 'hard'].map(bucket => `${DIFFICULTY_LABELS[bucket]} ${difficulty.achieved?.[bucket] ?? 0}/${difficulty.target?.[bucket] ?? 0}`).join(' · ')}</p>;
}

export function ProposalDraft({ proposal, onSwap, swappingQuestionId, onConfirm, confirming }) {
  const { items = [], report = {} } = proposal || {};
  const warnings = report.warnings || [];
  const deviations = report.deviations || [];

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-lg border border-border p-4">
        <h4 className="mb-2 text-sm font-semibold">Resumo do balanceamento</h4>
        <p className="text-xs text-muted-foreground">
          {items.length} questões selecionadas · seed {proposal?.seed}
        </p>
        <DifficultySummary difficulty={report.difficulty} />
        {deviations.length > 0 && (
          <ul className="mt-2 space-y-1 text-xs text-amber-700">
            {deviations.map((d, i) => (
              <li key={i}>
                Redistribuição: {d.from} → {d.to}: {d.count} {d.count === 1 ? 'questão' : 'questões'} (sem estoque)
              </li>
            ))}
          </ul>
        )}
        {warnings.map((w, i) => (
          <p
            key={i}
            className="mt-2 rounded bg-destructive/10 px-2 py-1 text-xs font-medium text-destructive"
          >
            {w}
          </p>
        ))}
      </div>

      <ul className="flex flex-col gap-2">
        {items.map(item => (
          <li
            key={item.question_id}
            className="flex items-center gap-3 rounded-lg border border-border p-3"
          >
            <Badge variant="outline">{item.descriptor_code}</Badge>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm">{item.question.description}</p>
              <p className="text-xs text-muted-foreground">{item.question.difficulty_label}</p>
            </div>
            <Button
              type="button"
              variant="outline"
              size="xs"
              disabled={swappingQuestionId === item.question_id || confirming}
              onClick={() => onSwap(item)}
            >
              {swappingQuestionId === item.question_id ? 'Trocando…' : 'Trocar'}
            </Button>
          </li>
        ))}
      </ul>

      <Button
        type="button"
        onClick={onConfirm}
        disabled={confirming || items.length === 0}
      >
        Confirmar e criar simulado
      </Button>
    </div>
  );
}
